import React from 'react';

const ObjectViewContext = React.createContext<any>({});

export default ObjectViewContext;
